import { graphql, useStaticQuery } from 'gatsby'
import { Artisan } from '.'

type MicrocmsData = {
  allArtisan: {
    nodes: Artisan[]
  }
}
export const useAllArtisans = () => {
  const data = useStaticQuery<MicrocmsData>(graphql`
    {
      allArtisan {
        nodes {
          workshop
          workshopEn
          coordinates
          prefectureIndex
          prefecture
          city
          prefectureEn
          cityEn
          blogIds
        }
      }
    }
  `)

  return data.allArtisan.nodes
}
